<template>
    <div>
        <div v-if="showExpiredNotice" class="alert alert-warning d-flex align-items-center justify-content-between mb-3" role="alert">
            <span>{{ $t('pdfView.offer_expired') }} {{ $t('pdfView.offer_expired_contact') }}</span>
            <button type="button" class="close ml-2" @click="showExpiredNotice = false" aria-label="Stäng">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <flicking-carousel v-if="!isSigned && !disableProductOptionCarousel" data-cta-anchor :panels="quoteOptions" @panelClick="onPanelClick($event.idx)" :borders="false">
            <template #panel="{ idx: quoteOptionIdx, panel: quoteOption }">
                <div class="cursor-pointer" role="button">
                    <img :src="companyPdfviewUrl" class="company-pdf-preview my-3 img-wiggle" draggable="false" />
                    <div class="mb-3">
                        <div class="text-secondary h4">
                            {{quoteOption.name}}
                        </div>
                        <template v-if="!isSigned && quoteOption.recommended">
                            <br>
                            <div style="color:#228B22" class="mt-2">
                                <i class="far fa-thumbs-up"></i> Rekommenderat val!
                            </div>
                        </template>
                    </div>

                  <div v-if="quoteOption.extra_documents_with_pdf_url.length > 0">Mappen innehåller</div>
                    <div v-for="(doc, docIdx) in quoteOption.extra_documents_with_pdf_url.slice(0, maxExtraDocuments[quoteOptionIdx])" :key="docIdx" class="mb-2">
                        <a role="button" class="btn w-50" @click.prevent.stop="onClickExtraDocument(quoteOptionIdx, 1 + docIdx)">
                          <img v-if="doc.is_pdf && doc.pdf_thumbnail_url" :src="doc.pdf_thumbnail_url" class="img-fluid" style="width:50px">
                          <i class="fal fa-file-pdf mr-1" v-else></i>
                          <br>
                            {{doc.pdf_name}}
                        </a>
                    </div>
                    <a href="#"
                        class="btn w-50 mb-2"
                        v-if="quoteOption.extra_documents_with_pdf_url.length > maxExtraDocuments[quoteOptionIdx]"
                        @click.prevent.stop="increaseMaxExtraDocuments(quoteOptionIdx, 3)"
                    >
                        Visa fler dokument
                    </a>
                </div>
            </template>
        </flicking-carousel>
        <flicking-carousel v-if="false && (isSigned || hasDocuments) && !disableProductOptionCarousel" :panels="[1]" :capture-panel-clicks="false">
            <template #panel>
                <div class="pt-3 pb-2 px-3">
                  <h3 class="mb-4 text-center">
                      <i class="fal fa-folder-open mr-1" style="font-size:7rem"></i>
                  </h3>

                  <div class="mb-2">
                      <a
                          v-if="isSigned"
                          :href="`/signed/${quoteKey}`"
                          title="Signerat"
                          class="btn btn-lg w-100 text-left"
                      >
                          <i :class="`fal fa-file-contract mr-1`" style="min-width: 21px;"></i>
                          {{ signedQuoteOption.name }}
                      </a>
                  </div>

                  <slot name="documents"></slot>
                </div>
            </template>
        </flicking-carousel>

        <template v-if="!disablePdfViewer && !isSigned">
            <documents-modal
                :id="`options-modal`"
                :print-url="route('quotes.print', {key: quoteKey, quote_option_id: selectedQuoteOption.id})"
                :quote-key="quoteKey"
                :quote-option-id="selectedQuoteOption.id"
                :quote-option-name="selectedQuoteOption.name"
                :company-image-url="companyImageUrl"
                :main-pdf-name="selectedQuoteOption.main_pdf_name"
                :main-pdf-url="selectedQuoteOption.main_pdf_url"
                :main-pdf-is-pdf="selectedQuoteOption.main_pdf_is_pdf"
                :extra-documents="selectedQuoteOption.extra_documents_with_pdf_url"
                :initially-selected="selectedDocumentIdx[selectedQuoteOptionIdx]"
                :is-signed="isSigned"
                :signable="signable"
                :is-post-sale="false"
                :company-color="companyColor"
                :obscured="obscured"
                :sign-copy="quoteEsignButtonTxt  ? quoteEsignButtonTxt  : $t('sign.move_forward')"
                :contact-copy="contactCopy"
                @move-forward-with-quote-option="handleQuoteOptionInterest"
            >

              <template #quote-option-selector-button>
                  <button class="btn btn-primary" :style="`background-color: ${companyColor};`" type="button" data-toggle="collapse" :data-target="`#navbar-${uuid}`" :aria-controls="`#navbar-${uuid}`" aria-expanded="false" aria-label="Byt dokument" v-if="quoteOptions.length > 1">
                    <span class="mb-0 h5">
                      {{$t('sign.more_options')}}
                      <i class="when-collapsed fal fa-chevron-down ml-2"></i>
                      <i class="when-expanded fal fa-chevron-up ml-2"></i>
                    </span>
                  </button>
              </template>
              <template #quote-option-selector-collapsible>
                  <div class="collapse navbar-collapse" :id="`navbar-${uuid}`">
                    <ul class="navbar-nav mr-auto mt-2 pl-2">
                      <li class="nav-item" v-for="(quoteOption, idx) in quoteOptions" :key="idx" :class="idx == selectedQuoteOptionIdx ? 'active' : ''">
                        <a class="nav-link" href="#" data-toggle="collapse" :data-target="`#navbar-${uuid}`" @click.prevent="handleQuoteOptionSelect(idx)">{{quoteOption.name}} <span class="sr-only">(visas nu)</span></a>
                      </li>
                    </ul>
                  </div>
              </template>

            </documents-modal>
        </template>
        <!-- Also mounted for signed quotes: the checkout boots those straight
             to a read-only verifikat, reachable via the ?verifikat=1 deep link. -->
        <quote-checkout-iframe-modal
            v-if="useNewCheckout"
            :quote-key="quoteKey"
            :selected-product-id="interestedQuoteOptionId"
            selected-kind="option"
            :pending-signature="pendingVerifikat"
            :pending-order-ref="pendingOrderRef"
            :pending-ais-resume="pendingAisResume"
        ></quote-checkout-iframe-modal>

        <bank-id-modal
            v-else-if="!isSigned"
            id="bankid"
            :app-url="appUrl"
            :quote-key="quoteKey"
            :quote-options="quoteOptions"
            :initially-selected-id="interestedQuoteOptionId"
            :quote-esign-desc="quoteEsignDesc"
            :disable-pdf-viewer="disablePdfViewer"
            :sign-component-name="signComponentName"
            :sign-component-signee-name="signComponentSigneeName"
            :sign-component-signature-button-label="signComponentSignatureButtonLabel"
            :sign-component-item-description="signComponentItemDescription"
            :google-ads-conversion-event-targets="googleAdsConversionEventTargets"
            :meta-ads-conversion-pixel-ids="metaAdsConversionPixelIds"
            @view-quote-option="handleQuoteOptionSelect"
            :options-payments-method="optionsPaymentsMethod"
            :options-payments-dintero-profile-id="
                optionsPaymentsDinteroProfileId
            "
        >
            <template v-if="$slots['more-information-header']" #more-information-header><slot name="more-information-header"></slot></template>
            <template v-if="$slots['more-information-fieldset']" #more-information-fieldset><slot name="more-information-fieldset"></slot></template>
        </bank-id-modal>

        <!-- The page-level ask (SalesByte 2.0 design). It appears once the
             options have been scrolled past and opens the same #bankid host
             the documents modal's sign button targets. The spacer keeps it
             from covering the last content section. -->
        <template v-if="showPageCta">
            <div style="height: 6rem" aria-hidden="true"></div>
            <fixed-checkout-cta
                :label="quoteEsignButtonTxt ? quoteEsignButtonTxt : $t('sign.move_forward')"
                @activate="openCheckoutFromCta"
            ></fixed-checkout-cta>
        </template>
    </div>
</template>

<style lang="sass" scoped>
a:focus {
    outline: none;
    box-shadow: unset;
}

img.company-pdf-preview {
    display: block;

    width: 80%;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: contain;
    object-position: center center;

    transform: rotate(-10deg);

    outline: none;
}
</style>

<script setup>
import { computed, nextTick, onMounted, ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import { route } from "ziggy";

import DocumentsModal from "../modals/documents.vue";
import BankIdModal from "./modals/bankid.vue";
import DetailsModal from "../products/modals/details.vue";
import FixedCheckoutCta from "../fixedCheckoutCta.vue";

const props = defineProps({
    appUrl: { type: String, default: undefined },
    quoteKey: { type: String, default: undefined },
    quoteEsignDesc: { type: String, default: undefined },
    quoteEsignButtonTxt: { type: String, default: undefined },
    quoteOptionsIn: { type: Array, default: () => [] },
    companyPdfviewUrl: { type: String, default: undefined },
    companyImageUrl: { type: String, default: undefined },
    signComponentName: { type: String, required: true },
    signComponentSigneeName: { type: String, default: null },
    signComponentSignatureButtonLabel: { type: String, required: true },
    signComponentItemDescription: { type: String, default: null },
    isSigned: { type: Boolean, default: false },
    hasDocuments: { type: Boolean, required: true },
    signedQuoteOptionId: { type: Number, default: undefined },
    disablePdfViewer: { type: Boolean, default: false },
    disableProductOptionCarousel: { type: Boolean, default: false },
    signable: { type: Boolean, default: false },
    companyColor: { type: String, default: "" },
    googleAdsConversionEventTargets: { type: Array, required: true },
    metaAdsConversionPixelIds: { type: Array, required: true },
    optionsPaymentsMethod: { type: String, default: null },
    optionsPaymentsDinteroProfileId: { type: String, default: null },
    obscured: { type: Boolean, default: false },
    contactCopy: { type: String, default: "" },
});

const quoteOptions = ref(props.quoteOptionsIn.filter((option) => !props.isSigned || option.id === props.signedQuoteOptionId));
const selectedDocumentIdx = ref(quoteOptions.value.map(() => 0));
const maxExtraDocuments = ref(quoteOptions.value.map(() => 2));
const selectedQuoteOptionIdx = ref(0);
const uuid = uuidv4();
const interestedQuoteOptionId = ref(quoteOptions.value[0]?.id);
const useNewCheckout = ref(false);
const pendingVerifikat = ref(false);
const pendingOrderRef = ref(null);
const pendingAisResume = ref(false);
// Pennant 'checkout-fixed-cta', surfaced by quotes/view.blade.php. Parked off
// for now: with the flag off this CTA never renders and the legacy blade sign
// button keeps the page.
const fixedCtaEnabled = ref(false);

// The page-level CTA: signable, unsigned, and not an expired (obscured)
// quote whose panels only offer the contact path.
const showPageCta = computed(
    () => fixedCtaEnabled.value && props.signable && !props.isSigned && !props.obscured
);

function openCheckoutFromCta() {
    nextTick(() => window.jQuery("#bankid").modal("show"));
}
const showExpiredNotice = ref(false);
const signedQuoteOption = computed(() => quoteOptions.value.find((option) => option.id == props.signedQuoteOptionId));
const selectedQuoteOption = computed(() => quoteOptions.value[selectedQuoteOptionIdx.value]);

onMounted(() => {
    const flagMeta = document.querySelector('meta[name="checkout-iframe-enabled"]');
    const originMeta = document.querySelector('meta[name="checkout-iframe-origin"]');
    useNewCheckout.value = flagMeta?.getAttribute("content") === "1" && Boolean(originMeta?.getAttribute("content"));
    const ctaMeta = document.querySelector('meta[name="fixed-checkout-cta-enabled"]');
    fixedCtaEnabled.value = ctaMeta?.getAttribute("content") === "1";
    maybeAutoOpenVerifikat();
    maybeAutoOpenAisResume();
});

function setSelectedDocumentIdx(quoteOptionIdx, documentIdx) {
    selectedDocumentIdx.value.splice(quoteOptionIdx, 1, documentIdx);
}
function increaseMaxExtraDocuments(quoteOptionIdx, increaseBy) {
    maxExtraDocuments.value.splice(quoteOptionIdx, 1, maxExtraDocuments.value[quoteOptionIdx] + increaseBy);
}
function onPanelClick(idx) {
    const quoteOption = quoteOptions.value[idx];
    if (props.disablePdfViewer) {
        if (props.obscured) {
            showExpiredNotice.value = true;
            return;
        }
        window.open(quoteOption.main_pdf_url, "_blank");
        return;
    }
    setSelectedDocumentIdx(idx, 0);
    selectedQuoteOptionIdx.value = idx;
    nextTick(() => window.jQuery("#options-modal").modal("show"));
}
function onClickExtraDocument(idx, docIdx) {
    const quoteOption = quoteOptions.value[idx];
    const document = quoteOption.extra_documents_with_pdf_url[docIdx - 1];
    if (props.disablePdfViewer) {
        if (props.obscured) {
            showExpiredNotice.value = true;
            return;
        }
        window.open(document.pdf_url, "_blank");
        return;
    }
    selectedQuoteOptionIdx.value = idx;
    setSelectedDocumentIdx(idx, docIdx);
    nextTick(() => window.jQuery("#options-modal").modal("show"));
}
function handleQuoteOptionSelect(idx) {
    selectedQuoteOptionIdx.value = idx;
    setSelectedDocumentIdx(idx, 0);
}
function handleQuoteOptionInterest(quoteOptionId) {
    interestedQuoteOptionId.value = quoteOptionId;
}
function maybeAutoOpenVerifikat() {
    if (!useNewCheckout.value) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get("verifikat") !== "1") {
        return;
    }
    // `pending=1` is the return from a BankID app-switch whose signing
    // callback may not have landed yet (SignedQuoteController). The checkout
    // opens in a "preparing your signature" state and polls its way to the
    // verifikat, so the modal opens even though this page rendered unsigned.
    const pending = params.get("pending") === "1" && !props.isSigned;
    if (!props.isSigned && !pending) {
        return;
    }
    pendingVerifikat.value = pending;
    if (pending) {
        // The BankID order the checkout's wait should watch, so a cancelled
        // order exits the wait immediately instead of running out the clock.
        pendingOrderRef.value = params.get("order_ref") || null;
    }
    nextTick(() => window.jQuery("#bankid").modal("show"));
    if (pending) {
        // One-shot: once signed, the modal reloads the page on close, and a
        // URL still carrying the pending params would re-enter the wait after
        // it is already over.
        params.delete("verifikat");
        params.delete("pending");
        params.delete("order_ref");
        const query = params.toString();
        window.history.replaceState(
            window.history.state,
            "",
            window.location.pathname + (query ? `?${query}` : "") + window.location.hash,
        );
    }
}

function maybeAutoOpenAisResume() {
    if (!useNewCheckout.value) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get("ais_resume") !== "1") {
        return;
    }
    // The return leg of a Brite AIS app switch (deeplink_redirect on the Brite
    // session). Reopen the checkout so it resumes the bank-details assist; a
    // quote signed in the meantime just falls back to the plain view.
    if (!props.isSigned) {
        pendingAisResume.value = true;
        nextTick(() => window.jQuery("#bankid").modal("show"));
    }
    // One-shot: a reload or share of this URL must not re-enter the resume.
    params.delete("ais_resume");
    const query = params.toString();
    window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + (query ? `?${query}` : "") + window.location.hash,
    );
}
</script>
